import React from "react";
import { Row, Col } from 'antd';
import monthlyReturn from "../../../allocator-portal/public/assets/images/latestMonth.svg";
import AnnualReturn from "../../../allocator-portal/public/assets/images/AnnualReturn.svg";
import AnnualVolatility from "../../../allocator-portal/public/assets/images/AnnualVolatility.svg";
import yearOfDate from "../../../allocator-portal/public/assets/images/ytd.svg";
import strategy from "../../../allocator-portal/public/assets/images/Strategy.svg";
import subStrategy from "../../../allocator-portal/public/assets/images/SubStrategy.svg";

export default function Stats({
  ytdValue,
  annualReturnsValue,
  annualVolatilityValue,
  latestMonthValue,
  fundName,
  showStrategy = false,
  strategyValue,
  subStrategyValue
}) {
  return (
    <Row>
      <Col span={24}>
        <div className="text-center Fund-FontSize" style={{ fontSize : "22px" }}> {fundName} Statistics</div>
      </Col>
      <Col span={24}>
        <Row className="mt-4">
          <Col span={10} offset={1}>
            <Row class="align-items-center">
              <Col span={6} style={{ borderRadius: "10%" }}>
                <img src={AnnualVolatility} style={{ height: "50px", width: "50px" }} />
              </Col>
              <Col span={6} className="ml-2">
                <div className="FundStats-FontSize">{ytdValue ? parseFloat(ytdValue)?.toFixed(2) + "%" : "N/A"}</div>
                <h5 style={{ float : "left" }}>YTD</h5>
              </Col>
            </Row>
          </Col>
          <Col span={10} offset={1}>
            <Row class="align-items-center">
              <Col span={6} style={{ borderRadius: "10%" }}>
                <img src={AnnualReturn} style={{ height: "50px", width: "50px" }} />
              </Col>
              <Col span={12} className="ml-2">
                <div className="FundStats-FontSize">{annualReturnsValue ? parseFloat(annualReturnsValue)?.toFixed(2) + "%" : "N/A"}</div>
                <h5 style={{ float : "left" }}>Annual Returns</h5>
              </Col>
            </Row>
          </Col>
          <Col span={10} offset={1} className="mt-2">
            <Row class="align-items-center">
              <Col span={6} style={{ borderRadius: "10%" }}>
                <img src={yearOfDate} style={{ height: "50px", width: "50px" }} />
              </Col>
              <Col span={12} className="ml-2">
                <div className="FundStats-FontSize">{annualVolatilityValue ? parseFloat(annualVolatilityValue)?.toFixed(2) + "%" : "N/A"}</div>
                <h5 style={{ float : "left" }}>Annual Volatility</h5>
              </Col>
            </Row>
          </Col>
          <Col span={10} offset={1} className="mt-2">
            <Row class="align-items-center">
              <Col span={6} style={{ borderRadius: "10%" }}>
                <img src={monthlyReturn} style={{ height: "50px", width: "50px" }} />
              </Col>
              <Col span={12} className="ml-2">
                <div className="FundStats-FontSize">{latestMonthValue ? parseFloat(latestMonthValue)?.toFixed(2) + "%" : "N/A"}</div>
                <h5 style={{ float : "left" }}>Latest Month</h5>
              </Col>
            </Row>
          </Col>
          {showStrategy ? (
            <>
              <Col span={10} offset={1} className="mt-2">
                <Row class="align-items-center">
                  <Col span={6} style={{ borderRadius: "10%" }}>
                    <img src={strategy} style={{ height: "50px", width: "50px" }} />
                  </Col>
                  <Col span={12} className="ml-2">
                    <div className="FundStats-FontSize">{strategyValue ? strategyValue : "N/A"}</div>
                    <h5 style={{ float : "left" }}>Strategy</h5>
                  </Col>
                </Row>
              </Col>
              <Col span={10} offset={1} className="mt-2">
                <Row class="align-items-center">
                  <Col span={6} style={{ borderRadius: "10%" }}>
                    <img src={subStrategy} style={{ height: "50px", width: "50px" }} />
                  </Col>
                  <Col span={12} className="ml-2">
                    <div className="FundStats-FontSize">{subStrategyValue ? subStrategyValue : "N/A"}</div>
                    <h5 style={{ float : "left" }}>Sub Strategy</h5>
                  </Col>
                </Row>
              </Col>
            </>
          ): ("")}

        </Row>
      </Col>
    </Row>
  );
}
